export const allowedImageMIMETypes = [
    'image/png',
    'image/jpg',
    'image/jpeg',
];
